import React from 'react';

import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import { trans } from '../../../../localization/index';

class WalletManagementFilter extends React.Component {
  render() {
    const { createUserWallet } = this.props;
    return (
      <FilterWrapper>
        <InputWrapper>
          <button
            type="button"
            className="btn btn-red mr-2"
            onClick={createUserWallet}
          >
            {trans('merchant_wallet_create')}
          </button>
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

export default WalletManagementFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/components/WalletManagementFilter.jsx